import { z } from "zod/v4";

import { castToNumber, castToString, validateIdNotExponent } from "../utils";

export type ShopifyGqlIdType =
  | "Product"
  | "ProductVariant"
  | "AppSubscription"
  | "Metafield"
  | "CartTransform"
  | "DiscountAutomaticNode";

export const ShopifyProductVariantDtoSchema = z.object({
  productTitle: castToString,
  productId: validateIdNotExponent,
  variantTitle: castToString,
  variantId: validateIdNotExponent,

  variationPrices: z.record(z.string(), z.any()),
  variationComparePrices: z.record(z.string(), z.any()),

  sku: z.string().nullish(),
  handle: z.string().nullish(),
  inventory: castToNumber.nullish(),
  tags: z.string().nullish(),
  productType: z.string().nullish(),
  status: z.string().nullish(),
  price: castToNumber.nullish(),
  comparePrice: castToNumber.nullish(),

  subscriptionDiscount: castToNumber.nullish().default(null),
  subscriptionDiscountType: z.string().nullish().default(null),

  cogs: castToNumber.nullish(),
});

export type ShopifyProductVariantDto = z.infer<
  typeof ShopifyProductVariantDtoSchema
>;
